import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../Loading";
import { useHistory } from "react-router";
import { AppDispatch, ApplicationState } from "../../store";
import { signinRedirectCallback } from '../../store/User';
import AsyncStatus, { AsyncStatusEnum } from "../../model/common/AsyncStatus";
import { User } from "oidc-client";

const OidcCallbackPage = function() {
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const signinRedirectCallbackStatus = useSelector<ApplicationState, AsyncStatus>(state => state.user.signinRedirectCallbackStatus);
  const user = useSelector<ApplicationState, User | null>(state => state.user.user);
  
  useEffect(() => {
      dispatch(signinRedirectCallback());
  }, [dispatch]);
  
  useEffect(() => {
    if (signinRedirectCallbackStatus === AsyncStatusEnum.SUCCEEDED || signinRedirectCallbackStatus === AsyncStatusEnum.FAILED) {
      if (user && user.state) {
        history.push(user.state);
      } else {
        history.push("/");
      }
    }
  }, [signinRedirectCallbackStatus, user, history]);
  
    return (<Loading isLoading={true} />);
}

export default OidcCallbackPage;